import { ThemeOptions } from '@mui/material';

/**
 * App-wide surface treatment: cards sit on a hairline ring with a soft,
 * low-spread shadow instead of MUI's default elevation stack.
 *
 * This is the single change that most separates a dashboard that reads as
 * "designed" from one that reads as "default MUI" — heavy drop shadows make
 * every card shout at the same volume, so nothing reads as foreground. The
 * ring carries the card boundary; the shadow only lifts it off the page.
 *
 * Deliberately scoped to `MuiCard` rather than `MuiPaper`: Paper also backs
 * menus, popovers and dialogs, whose elevation is load-bearing.
 */
export default function Surfaces(theme: ThemeOptions) {
  const hairline = theme.palette?.grey?.[200] ?? '#DFE2E6';

  return {
    MuiCard: {
      defaultProps: {
        elevation: 0
      },
      styleOverrides: {
        root: {
          borderRadius: '14px',
          border: `1px solid ${hairline}`,
          boxShadow: '0 1px 2px rgba(0, 16, 72, 0.04), 0 8px 24px rgba(0, 16, 72, 0.04)',
          backgroundImage: 'none'
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          // Column headers become quiet, letter-spaced micro-labels so the
          // numbers in the body are what the eye lands on first.
          '& .MuiTableCell-root': {
            fontSize: '1.1rem',
            fontWeight: 600,
            letterSpacing: '0.08em',
            textTransform: 'uppercase' as const,
            color: theme.palette?.text?.secondary ?? '#697599'
          }
        }
      }
    }
  };
}
